import { FaEnvelope, FaInstagram, FaYoutube, FaFacebook, FaXTwitter } from "react-icons/fa6"; // using react-icons

function Footer() {
  return (

   
  
  <footer className="container mx-auto flex flex-col md:flex-row items-center justify-between gap-4 p-4 bg-white">

  {/* Left side - Logo */}
  <div>
    <p>© 2025 MemberMeld. A product of Reyspire Digital Software Pvt. Ltd.</p>
  </div>

  {/* Center Links */}
  <div className="flex items-center gap-6">
    <a href="/privacy" className="hover:text-blue-500">
      Privacy Policy
    </a>
    <a href="/tos" className="hover:text-blue-500">
      Terms of Service
    </a>
  </div>

  {/* Right side - Social Icons */}
  <div className="flex items-center space-x-6 text-gray-600 text-2xl">
    <a href="#contact" className="hover:text-blue-500">
      <FaEnvelope />
    </a>
    <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="hover:text-pink-500">
      <FaInstagram />
    </a>
    <a href="https://www.youtube.com/@MemberMeld" target="_blank" rel="noopener noreferrer" className="hover:text-red-500">
      <FaYoutube />
    </a>
    {/* <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="hover:text-blue-700">
      <FaFacebook />
    </a> */}
    <a href="https://x.com" target="_blank" rel="noopener noreferrer" className="hover:text-black">
      <FaXTwitter />
    </a>
  </div>

</footer>


  );
}

export default Footer;